import type { Streetscape } from './types';

/** Reusable street looks. Each leg picks the one closest to the real area. */
export const MARKET: Streetscape = {
  mix: [{ kind: 'market', weight: 4 }, { kind: 'shophouse', weight: 4 }, { kind: 'office', weight: 1 }],
  median: 'barrier', trees: 1, medianPalms: false, umbrellas: 8, lights: true,
};

export const TOWN: Streetscape = {
  mix: [{ kind: 'shophouse', weight: 6 }, { kind: 'office', weight: 1 }, { kind: 'market', weight: 1 }],
  median: 'barrier', trees: 2, medianPalms: false, umbrellas: 5, lights: true,
};

export const RING_ROAD: Streetscape = {
  mix: [{ kind: 'office', weight: 3 }, { kind: 'shophouse', weight: 3 }, { kind: 'tower', weight: 1 }],
  median: 'grass', trees: 3, medianPalms: true, umbrellas: 2, lights: true,
};

export const UNIVERSITY: Streetscape = {
  mix: [{ kind: 'compound', weight: 3 }, { kind: 'office', weight: 2 }, { kind: 'shophouse', weight: 1 }],
  median: 'grass', trees: 4, medianPalms: true, umbrellas: 1, lights: true,
};

export const RESIDENTIAL: Streetscape = {
  mix: [{ kind: 'compound', weight: 6 }, { kind: 'office', weight: 1 }],
  median: 'grass', trees: 4, medianPalms: true, umbrellas: 0, lights: true,
};

export const AIRPORT_CITY: Streetscape = {
  mix: [{ kind: 'tower', weight: 4 }, { kind: 'office', weight: 3 }],
  median: 'grass', trees: 3, medianPalms: true, umbrellas: 0, lights: true,
};

/** Wide highway edges (the Winneba road out to Kasoa): scattered shops, compounds and lorry stops. */
export const HIGHWAY: Streetscape = {
  mix: [{ kind: 'shophouse', weight: 3 }, { kind: 'compound', weight: 2 }, { kind: 'market', weight: 1 }],
  median: 'grass', trees: 2, medianPalms: false, umbrellas: 3, lights: true,
};

/** Village streets: low compounds, a few shops, roadside stalls, palms; no street lamps. */
export const VILLAGE: Streetscape = {
  mix: [{ kind: 'compound', weight: 5 }, { kind: 'shophouse', weight: 2 }, { kind: 'market', weight: 1 }],
  median: 'grass', trees: 3, medianPalms: true, umbrellas: 4, lights: false,
};

/** Villages on the hills (Mampong, Tutu): more trees, fewer shops. */
export const HILL_VILLAGE: Streetscape = {
  mix: [{ kind: 'compound', weight: 6 }, { kind: 'shophouse', weight: 1 }],
  median: 'grass', trees: 5, medianPalms: false, umbrellas: 2, lights: false,
};

/** Climbing through the forest (Aburi): trees close on both sides, hardly any buildings. */
export const FOREST_ROAD: Streetscape = {
  mix: [{ kind: 'compound', weight: 4 }, { kind: 'shophouse', weight: 1 }],
  median: 'grass', trees: 8, medianPalms: false, umbrellas: 1, lights: false,
};

/** A town on the ridge (Akropong): shops and compounds, a few lamps. */
export const HILL_TOWN: Streetscape = {
  mix: [{ kind: 'shophouse', weight: 4 }, { kind: 'compound', weight: 3 }, { kind: 'market', weight: 1 }],
  median: 'grass', trees: 3, medianPalms: false, umbrellas: 3, lights: true,
};
